import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ics-matte.webp")